import {currentUserIsAdmin} from '@netx/core-permissions-next/enablers/currentUserIsAdmin';
import {currentCartIsNotEmpty} from './currentCartIsNotEmpty';

export const canManageCurrentCartVisibility = () =>
	currentCartIsNotEmpty() && currentUserIsAdmin();

export default canManageCurrentCartVisibility;
